module.exports = __webpack_public_path__ + "media/images/sort-asc-7e2ccbc3b7b736251403b238014dcacc.gif";